// FAQ Template for Pricing Pages
// This template generates FAQ questions and answers with dynamic placeholders

export const generatePricingFAQ = ({
  make = "",
  model = "",
  city = "",
  state = "",
  mileage = "",
  minPrice = "",
  maxPrice = "",
  chargingTime = "",
}) => {
  const makeModel = make && model ? `${make} ${model}` : "[Make Model]";
  const cityState = city && state ? `${city}, ${state}` : "[City], [State]";
  const mileageText = mileage || "[Mileage]";
  const minPriceText = minPrice || "[Min Range]";
  const maxPriceText = maxPrice || "[Max Range]";
  const chargingTimeText = chargingTime || "[Charging Time]";

  return [
    {
      question: `What is the mileage of ${makeModel}?`,
      answer: `The ${makeModel} is designed for maximum uptime, delivering a mileage of approximately ${mileageText} km per full charge, allowing for a full day of operations in ${city} with minimal charging breaks.`,
    },
    {
      question: `What is the on-road price of the ${makeModel} in ${cityState}?`,
      answer: `The ${makeModel} on-road price in ${city} typically ranges between ₹ ${minPriceText} and ₹ ${maxPriceText}.\n\nDisclaimer: This range is indicative. The final price may vary based on the specific variant, latest government subsidies (like PM E-DRIVE), insurance premiums, and local RTO taxes.`,
    },
    {
      question: `Where is ${make} electric auto showroom?`,
      answer: `Instead of visiting a single-brand dealer, visit Turno, the leading marketplace for electric three-wheelers. We offer a multi-brand experience where you can compare the ${makeModel} with other top-tier EVs, take test drives, and get expert advice all in one place.`,
    },
    {
      question: `What is ${make} electric auto battery price?`,
      answer: `The battery is the core of the ${makeModel} electric auto price. While individual battery prices vary based on capacity (kWh), Turno provides comprehensive warranty support and battery health monitoring via our app to ensure you get the longest life out of your power pack.`,
    },
    {
      question: `How long does ${makeModel} take to fully charge the battery?`,
      answer: `On a standard charger, the ${makeModel} takes about ${chargingTimeText} hours to reach 100%. Many models also support fast-charging options that can provide a significant boost in under 2 hours.`,
    },
    {
      question: `How is an electric auto cheaper than diesel or CNG in ${cityState}?`,
      answer: `In ${city}, running an electric auto costs roughly ₹0.50 to ₹1.00 per km, whereas diesel and CNG can cost ₹3.00 to ₹4.00 per km. Over 5 years, this can lead to savings of over ₹5–6 Lakh, directly increasing your take-home profit.`,
    },
  ];
};
